import { useMemo } from 'react';
import { Card, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useCobConfig } from "../../../../CobConfigContext";
import { replacePlaceholders } from "../../../../../../utils/introductory-message.utils";
import styles from "./Introduction.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const GetIntroductionTID = () => getTestIds();
export const Introduction = () => {
  var _relationship$buyer$f;
  const {
    relationship
  } = useCobConfig();
  const {
    IntroductionTestIds
  } = useMemo(() => GetIntroductionTID(), []);
  return /*#__PURE__*/_jsx(Card, {
    className: styles.card,
    "data-testid": IntroductionTestIds.Card(),
    children: /*#__PURE__*/_jsx(Typography, {
      showWhiteSpaces: true,
      breakWords: true,
      "data-testid": IntroductionTestIds.Text(),
      children: replacePlaceholders(relationship.customNotificationText, (_relationship$buyer$f = relationship.buyer.firstName) !== null && _relationship$buyer$f !== void 0 ? _relationship$buyer$f : '', relationship.vendor.name)
    })
  });
};